import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { teamsAPI } from '@/lib/api';
import { useTeam, Team } from '@/stores/team-store';

export const useTeams = () => {
  const {
    currentTeam,
    teams,
    isLoading: storeLoading,
    setTeams,
    setLoading,
    getCurrentTeamId,
    switchTeam,
  } = useTeam();

  const { data: teamsResponse, isLoading: queryLoading, error } = useQuery({
    queryKey: ['teams'],
    queryFn: () => teamsAPI.getTeams(),
  });

  const isLoading = storeLoading || queryLoading;

  // Update store when teams data is fetched
  useEffect(() => {
    if (teamsResponse?.data) {
      const fetchedTeams = teamsResponse.data as Team[];
      setTeams(fetchedTeams);
    }
  }, [teamsResponse, setTeams]);

  // Set loading state
  useEffect(() => {
    setLoading(queryLoading);
  }, [queryLoading, setLoading]);

  return {
    currentTeam,
    teams,
    isLoading,
    error,
    getCurrentTeamId,
    switchTeam,
    hasTeams: teams.length > 0,
  };
};